import {
  ActionIcon,
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  GridCol,
  Input,
  Menu,
  rem,
  Select,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import {
  IconArrowNarrowRight,
  IconBrandBootstrap,
  IconCaretDown,
  IconFileExport,
  IconFileTypography,
  IconFileUpload,
  IconSearch,
  IconTimeDuration15,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import * as xlsx from "xlsx";
import { repositoryPos } from "../../../../_base/_const/_constVar";
import _breadcrumb from "../../../../_base/component/_layout/_breadcrumb";
import { AvatarUtils } from "../../../../common/ColorByName/AvatarUtils";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../../common/FormatDate/FormatDate";
import { _localization } from "../../../../config/location";
import { green, teal } from "../../../../const/variables";
import { MessageResponse } from "../../../../model/MessageResponse";
import {
  getMasterOrgSelect,
  getTblInventoryTransactionTypeInWard,
} from "../../../../service/getSelectApi";
import SuggestItemWardModal from "../../WarehouseOutWard/components/SuggestItemWardModal";

interface InwardRequestInterface {
  type: number;
  createDate: string | null;
  sourceCodeParent: string;
  sourceType: string;
  sourceTypeName: string;
  sourceTranCode: string;
  depName: string;
  workAddress: string;
  invName: string;
  roleName: string;
  empName: string;
  note: string | null;
  reasonReturn: string | null;
}

const RequestInWardTransaction = () => {
  const navigate = useNavigate();
  // Reference data from another table

  //data and fetching state
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<InwardRequestInterface[]>([]);
  const [dataInv, setDataInv] = useState<ComboboxItem[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [dataInventoryTransactionType, setDataInventoryTransactionType] =
    useState<ComboboxItem[]>([]);
  const [dataBranchSelect, setDataBranchSelect] = useState<ComboboxItem[]>([]);
  //table state
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const sizeGrid = { base: 6, sm: 3, md: 3, lg: 2, xl: 2 };

  //count
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);

  const search = {
    keySearch: "",
    fromTransationDate: new Date(
      new Date(
        new Date(new Date().setDate(new Date().getDate() - 14)).setHours(
          0,
          0,
          0,
          0,
        ),
      ).getTime() +
        7 * 60 * 60 * 1000,
    )?.toISOString(),
    toTransationDate: new Date(
      new Date(
        new Date(new Date().setDate(new Date().getDate() + 1)).setHours(
          0,
          0,
          0,
          0,
        ),
      ).getTime() +
        7 * 60 * 60 * 1000,
    )?.toISOString(),
    sourceType: "",
    invId: "",
    status: "",
    empId: "",
    // branchId: String(
    //   JSON.parse(localStorage.getItem("userLoginHeader") || "{}")?.branchId ||
    //     "",
    // ),
    branchId: "",
  };

  const columns = React.useMemo<MRT_ColumnDef<InwardRequestInterface>[]>(
    () => [
      {
        accessorKey: "index",
        header: "STT",
        size: 50,
        enableSorting: false,
        enableResizing: false,
        Cell: ({ row: { index } }: any) => index + 1,
      },
      {
        accessorKey: "sourceTranCode",
        header: "Phiếu xuất",
        size: 180,
        Cell: ({ renderedCellValue, row }: any) => (
          <Badge
            radius="sm"
            variant="dot"
            size="lg"
            style={{ cursor: "pointer" }}
            color={renderedCellValue === null ? "red" : green.base}
            onDoubleClick={() => {
              if (row?.original?.sourceId) {
                handleDetail(
                  row?.original?.sourceType,
                  row?.original?.sourceCodeParent,
                  true,
                  row?.original?.sourceId,
                );
              }
            }}
          >
            {renderedCellValue === null ? null : renderedCellValue}
          </Badge>
        ),
      },
      {
        accessorKey: "createDate",
        header: "Thời gian tạo",
        size: 150,
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "finishDate",
        header: "Thời gian hoàn thành",
        size: 170,
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "sourceTypeName",
        header: "Lý do",
        Cell: ({ row, renderedCellValue }) => (
          <Badge
            color={getColorType(row.original.sourceType ?? null)}
            variant="light"
            bd={`1px solid ${getColorType(row.original.sourceType ?? null)}`}
          >
            {renderedCellValue}
          </Badge>
        ),
        size: 250,
      },
      {
        accessorKey: "branchName",
        header: "Chi nhánh",
        Cell: ({ renderedCellValue, row }) => (
          <Text fw={700} size="sm">
            {renderedCellValue}
          </Text>
        ),
        size: 200,
      },
      {
        accessorKey: "invName",
        header: "Kho",
        Cell: ({ renderedCellValue, row }) => (
          <Text fw={700} size="sm">
            {renderedCellValue}
          </Text>
        ),
        size: 200,
      },
      {
        accessorKey: "depName",
        header: "Phòng ban",
        Cell: ({ renderedCellValue }: any) => (
          <Text fw={700} size="sm">
            {renderedCellValue}
          </Text>
        ),
        size: 250,
      },
      {
        accessorKey: "workAddress",
        header: "Địa điểm làm việc",
        Cell: ({ renderedCellValue }: any) => (
          <Text fw={700} size="sm">
            {renderedCellValue}
          </Text>
        ),
        size: 250,
      },
      {
        accessorKey: "roleName",
        header: "Chức danh",
        Cell: ({ renderedCellValue }) => (
          <Text size="11.5px">{renderedCellValue}</Text>
        ),
      },
      {
        accessorKey: "empName",
        header: "Họ & Tên",
        size: 250,
        Cell: ({ renderedCellValue, cell, row }) => (
          <Flex align="center">
            <AvatarUtils value={row.original.empName?.split("-")[1]} /> -
            <Text fw={600}>{row.original.empName?.split("-")[0]}</Text>
          </Flex>
        ),
      },
      {
        accessorKey: "a",
        header: "GHNN",
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label={renderedCellValue}>
            <Text size="sm" maw={300}>
              {renderedCellValue}
            </Text>
          </Tooltip>
        ),
      },
      {
        accessorKey: "returnReason",
        header: "Lý do đổi trả",
      },
      {
        accessorKey: "note",
        header: "Ghi chú",
        size: 250,
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label={renderedCellValue}>
            <Text size="sm">{renderedCellValue}</Text>
          </Tooltip>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableResizing: false,
        size: 80,
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue, row, table }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Tooltip label="Nhập kho">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="blue"
                onClick={async () => {
                  inward(
                    row?.original?.sourceTranCode,
                    row?.original?.sourceType,
                  );
                }}
              >
                <IconArrowNarrowRight size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            {/* <Tooltip label="Sản phẩm đề xuất">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="violet"
                onClick={async () => {
                  openSuggestModal(
                    row?.original?.sourceTranCode ?? "",
                    row?.original?.sourceType ?? ""
                  );
                }}
              >
                <IconEyeSearch size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip> */}
          </Box>
        ),
      },
    ],
    [dataInventoryTransactionType, dataInv],
  );

  const form = useForm({
    mode: "uncontrolled",
    initialValues: search,
  });

  const handleExport = () => {
    try {
      const worksheet = xlsx.utils.json_to_sheet(data);
      const workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, "Data");
      xlsx.writeFile(workbook, "danh-sach-phieu-xuat-kho.xlsx");
      toast.success("Export excel thành công", { autoClose: 1500 });
    } catch (error) {
      toast.error("Export excel thất bại", { autoClose: 1500 });
    }
  };

  const getColorType = (type: string | null) => {
    switch (type) {
      case "NHAP_DIEU_CHUYEN_CHI_NHANH":
        return "#f06418";
      case "NHAP_DIEU_CHUYEN_CHI_NHANH_SERIAL":
        return "#ffab09";
      case "NHAP_HUY":
        return "#d9d02f";
      case "NHAP_DIEU_CHINH":
        return "#6bd731";
      case "NHAP_DIEU_CHUYEN_NOI_BO":
        return "#09b8ff";
      case "NHAP_DIEU_CHUYEN_NOI_BO_SERIAL":
        return "#1f32c4";
      case "NHAP_TRA_NCC":
        return "#2bdd66";
      case "NHAP_BAN":
        return teal.light;
      case null:
        return "rgba(0, 0, 0, 0)";
      case "NOI_BO":
        return "#656a7e";
    }
  };

  const inward = (sourceTranCode: string, sourceType: string) => {
    navigate("/warehouse-config/create-warehouse-in-ward", {
      state: {
        sourceCode: sourceTranCode,
        sourceType: sourceType,
      },
    });
  };

  const detailData = (
    id: string | number,
    type: string | number | null,
    isLocked: boolean,
  ) => {
    navigate("/warehouse-config/detail-warehouse-out-ward", {
      state: {
        id: id,
        type: type?.toString().replace("NHAP", "XUAT"),
        isLocked: isLocked,
      },
    });
  };

  const handleDetail = (
    type: string,
    sourceCode: string,
    isLocked: boolean,
    id?: string | number,
  ) => {
    switch (type) {
      case "NHAP_HANG_DOI_TRA":
        detailOrder(sourceCode);
        break;
      default:
        if (id) detailData(id, type, isLocked);
        break;
    }
  };

  const openSuggestModal = (sourceCode: string, sourceType: string) => {
    try {
      modals.openConfirmModal({
        title: (
          <>
            <Title order={5}>Danh sách sản phẩm!</Title>
          </>
        ),

        size: "auto",
        children: (
          <SuggestItemWardModal
            sourceType={sourceType}
            sourceCode={sourceCode}
          />
        ),
        confirmProps: { display: "none" },
        cancelProps: { display: "none" },
      });
    } catch (error) {
      console.error(error);
      return;
    }
  };

  const detailOrder = async (sourceCode: string) => {
    const url = `/api/v1/CreateSellItem/details?orderNumber=${sourceCode}`;
    const response = await repositoryPos.get<MessageResponse<any>>(url);
    const data = response?.data;

    if (response && response.success) {
      const isReturnOrder = sourceCode.includes("DT");
      navigate(isReturnOrder ? "/sell/return-order" : "/sell/view-order", {
        state: {
          id: data?.orderHeader.id,
          orderNumber: data?.orderHeader.orderNumber,
          orderType: data?.orderHeader.orderTypeId.toString(),
          actionType: "view",
          ...(isReturnOrder && { action: "tra" }),
        },
      });
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    let _softing = "";
    let isOrder = false;
    if (sorting && sorting.length > 0) {
      let _q = sorting[0];
      if (_q) {
        _softing = _q.id;
        isOrder = _q.desc;
      }
    }

    try {
      const queryParams = {
        Skip: pagination?.pageIndex * pagination?.pageSize,
        Take: pagination?.pageSize,
        KeySearch: form.getValues()?.keySearch,
        FromDate: form.getValues()?.fromTransationDate,
        ToDate: form.getValues()?.toTransationDate,
        SourceType: form.getValues()?.sourceType,
        BranchId: form.getValues()?.branchId,
        sort: _softing,
        isOrder: isOrder,
      };
      const baseUrl =
        "/api/v1/RequestInventoryTransaction/get-list-request-transaction-in-ward?";
      const url = Object.entries(queryParams)
        .reduce((acc, [key, value]) => {
          if (value !== undefined && value !== "" && value !== null) {
            return `${acc}&${key}=${encodeURIComponent(value)}`;
          }
          return acc;
        }, baseUrl)
        .replace("&", "");
      const response = await repositoryPos.get(url);
      if (response && response.success) {
        let result = response.data;
        setIsLoading(false);
        setData(result || []);
        setRowCount(response.totalCount);
        table.resetRowSelection();
      } else setData([]);
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const fetchdataInventoryTransactionType = async () => {
    const response = await getTblInventoryTransactionTypeInWard();

    setDataInventoryTransactionType(
      response.map((type) => ({ value: type.value, label: type.text })),
    );
  };

  const getDataBranchSelect = async () => {
    const res = await getMasterOrgSelect();
    setDataBranchSelect(
      res
        ?.filter(
          (item) =>
            item.text != null && item.value != null && item.value !== "-1",
        )
        ?.map((item) => ({
          value: item.value?.toString(),
          label: `${item.att1} - ${item.text}`,
        })),
    );
  };

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  useEffect(() => {
    fetchData();
  }, [sorting, pagination, deleteViewStatus]);

  useEffect(() => {
    getDataBranchSelect();
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,

    positionToolbarAlertBanner: "bottom",
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.sourceTranCode?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["index", "sourceTranCode", "mrt-row-select"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: true,
    enableFilters: false,
    enableColumnActions: false,
    rowCount,
    onSortingChange: setSorting,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: () => ({
      style: {
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
      sorting,
    },
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  return (
    <>
      <div
        style={{ border: "1px solid #dee2e6", padding: "5px" }}
        ref={headerRef}
      >
        <Flex
          gap="md"
          justify={"space-between"}
          align="center"
          direction="row"
          wrap="wrap"
          w={"100%"}
        >
          <_breadcrumb></_breadcrumb>
          <Flex gap="md" align="center" direction="row" wrap="wrap">
            <Menu shadow="md" width={200}>
              <Menu.Target>
                <Button
                  // size="xs"
                  rightSection={
                    <IconCaretDown
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                >
                  Chức năng
                </Button>
              </Menu.Target>

              <Menu.Dropdown>
                <Menu.Label>Application</Menu.Label>
                <Menu.Item
                  leftSection={
                    <IconFileExport
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                  onClick={handleExport}
                >
                  Export Excel
                </Menu.Item>
                <Tooltip label={"Chức năng đang update"}>
                  <Menu.Item
                    leftSection={
                      <IconFileUpload
                        style={{ width: rem(14), height: rem(14) }}
                      />
                    }
                  >
                    Import Excel
                  </Menu.Item>
                </Tooltip>
              </Menu.Dropdown>
            </Menu>
          </Flex>
        </Flex>
        <form>
          <Grid mt={"10px"}>
            <GridCol span={sizeGrid}>
              <Input
                w={"100%"}
                placeholder="Từ khoá"
                type="text"
                leftSection={<IconSearch color="#15aabf" />}
                key={form.key("keySearch")}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    await fetchData();
                  }
                }}
                {...form.getInputProps("keySearch")}
              />
            </GridCol>
            <GridCol span={sizeGrid}>
              <Select
                placeholder={"Loại chứng từ gốc"}
                searchable
                clearable
                leftSection={<IconFileTypography color="#15aabf" />}
                comboboxProps={{
                  transitionProps: { transition: "pop", duration: 200 },
                }}
                data={dataInventoryTransactionType}
                nothingFoundMessage={"Loading..."}
                key={form.key("sourceType")}
                onClick={() => {
                  if (dataInventoryTransactionType.length === 0) {
                    fetchdataInventoryTransactionType();
                  }
                }}
                {...form.getInputProps("sourceType")}
              />
            </GridCol>
            <Grid.Col span={sizeGrid}>
              <DatePickerInput
                size="sm"
                placeholder="Chọn ngày bắt đầu"
                locale="vi"
                valueFormat="DD/MM/YYYY"
                leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
                value={
                  form.getValues().fromTransationDate &&
                  form.getValues().fromTransationDate.length > 0
                    ? new Date(form.getValues().fromTransationDate)
                    : null
                }
                onChange={(e) => {
                  form.setValues((prev) => ({
                    ...prev,
                    fromTransationDate: formatDateNotTimeZone(e) ?? "",
                  }));
                }}
                clearable
              />
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <DatePickerInput
                size="sm"
                placeholder="Chọn ngày kết thúc"
                locale="vi"
                valueFormat="DD/MM/YYYY"
                leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
                value={
                  form.getValues().toTransationDate &&
                  form.getValues().toTransationDate.length > 0
                    ? new Date(form.getValues().toTransationDate)
                    : null
                }
                onChange={(e) => {
                  form.setValues((prev) => ({
                    ...prev,
                    toTransationDate: formatDateNotTimeZone(e) ?? "",
                  }));
                }}
                clearable
              />
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <Select
                placeholder="Nhập mã hoặc tên chi nhánh"
                data={dataBranchSelect}
                searchable
                clearable
                value={form.getValues()?.branchId || null}
                leftSection={<IconBrandBootstrap color="#15aabf" />}
                onChange={(e) => {
                  form.setValues((prev) => ({
                    ...prev,
                    branchId: e ? e : "",
                  }));
                }}
                nothingFoundMessage="Không tìm thấy dữ liệu !"
              />
            </Grid.Col>
            <GridCol span={sizeGrid}>
              <Button
                leftSection={<IconSearch size={14} />}
                color="blue"
                variant="outline"
                onClick={async () => {
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </GridCol>
          </Grid>
        </form>
      </div>

      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default RequestInWardTransaction;
